import React from 'react'
import MaintenancePage from '../pages/maintenance/MaintenancePage'

interface MaintenanceWrapperProps {
  children: React.ReactNode
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({children}) => {
  // Maintenance Mode Configuration
  // Set this to true to enable maintenance mode
  // Set this to false to disable maintenance mode
  // If maintenance mode is enabled, show the maintenance page
  const MAINTENANCE_MODE = false // Change this to true to enable maintenance mode
  if (MAINTENANCE_MODE) {
    return <MaintenancePage />
  }

  // Otherwise, render the normal app
  return <>{children}</>
}

export default MaintenanceWrapper
